/**
 * User Actions need to be GDPR exportable and should follow certain naming conventions.
 * Please refer to the "INCLUSION LIST GUIDANCE TO FOLLOW" section at https://microsoft.sharepoint.com/teams/opgngpx/SitePages/Exporting%20OTel%20Data.aspx for naming conventions when adding an entry here.
 * Please add new entries in alphabetical order.
 */ export const UserAction = {
    /**
   * User removed a label
   */ RemoveLabel: 'RemoveLabel',
    /**
   * User set a new label
   */ ApplyLabel: 'ApplyLabel',
    /**
   * User opened or dismissed the label picker
   */ ShowOrHideLabelPicker: 'ShowOrHideLabelPicker'
};
